/**
 * 该文件为脚本自动生成文件，请勿随意修改。如需修改请联系 PMC
 * */

import type { TdGuideProps } from './type';

export const guideDefaultProps: TdGuideProps = {
  hideCounter: false,
  hidePrev: false,
  hideSkip: false,
  highlightPadding: 8,
  mode: 'popup',
  showOverlay: true,
  zIndex: 999999,
};
